export const LetterCategoryEnum = {
  'Account Balance': 1,
  Notification: 2,
  Verification: 3,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/LetterCategoryEnum.js